<div class="d-flex flex-column">
  <div class="d-flex flex-dir-column mb-2" *ngIf="uploader.queue.length > 0">
    <mat-progress-bar mode="determinate"
                      [value]="uploader.progress"></mat-progress-bar>
    <div class="d-flex flex-dir-row" *ngIf="showProgress">
      <div class="flex-grow-1 fs-7">
        Uploading Files: {{uploader.queue.length}} &nbsp;Size: {{totalSize/ 1024 / 1024 | number:'.2' }} MB
      </div>
      <div class="fs-7">{{uploader.progress}}%</div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <label class="pointer d-flex" for="upload-{{id}}" style="display: inline">
      <mat-icon class="fs-6 text-secondary">attach_file</mat-icon>
    </label>
    <input id="upload-{{id}}" class="show-for-sr" (change)="startUpload($event)" type="file" value="null" [accept]="acceptTypes" ng2FileSelect [uploader]="uploader" multiple>
  </div>
</div>
